import React, { useState, useEffect } from "react";
import "../../../../client/assets/css/cms/Country.css";
import DataTable from "react-data-table-component";
import { RiEdit2Line } from "react-icons/ri";
import { RiDeleteBinFill } from "react-icons/ri";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useDispatch, useSelector } from "react-redux";
import CommonModal from "../../utils/commonModal";
import Alert from "@mui/material/Alert";
import Loading from "../../../components/utils/loader";
import { CUSTOM_STYLE_PERMISSION_DATA_TABLE } from "../../../constants/cms";
import {
  getDomainList,
  cleardeleteDomainList,
  deleteDomainList,
  putDomainId,
  postDomain,
} from "../../../../store/slices/domain";

function Domain(props) {
  const {
    domainListData,
    domainListLoading,
    deleteDomainListLoading,
    deleteDomainListData,
    deleteDomainListError,
    postDomainDataError,
    postDomainDataLoading,
    putDomainIdDataLoading,
    putDomainIdData,
    postDomainData,
    putDomainIdDataError,
    message,
  } = useSelector((state) => state.cmsDomain);
  const dispatch = useDispatch();
  const [addDomainName, setAddDomainName] = useState({
    id: null,
    email_domain_mobile: "",
    block_type: "",
  });
  const domain_type = [
    { label: "mobile", value: "1" },
    { label: "email_domain", value: "2" },
  ];
  const [lengthError, setLengthError] = useState();
  const [open, setOpen] = useState(false);
  const userPermission = useSelector(
    (state) => state.userData?.userPermission?.data
  );
  const [itemToDelete, setItemToDelete] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [tableData, setTableData] = useState(null);
  const [tableCustomData, setTableCustomData] = useState([
    {
      name: "Id",
      selector: (row) => row.id,
    },
    {
      name: "Domain",
      selector: (row) => row.email_domain_mobile,
      center: "true",
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          {userPermission?.find((item) => item?.name == "Can Edit Domain") && (
            <span
              className={"icon_edit"}
              onClick={() =>{
                setAddDomainName({ id: row?.id, email_domain_mobile: row?.email_domain_mobile, block_type: row?.block_type })
              }
              }
            >
              <RiEdit2Line />
            </span>
          )}
          {userPermission?.find(
            (item) => item?.name == "Can Delete Domain"
          ) && (
            <button
              className={"icons_delete"}
              onClick={() => {
                setOpen(true);
                setItemToDelete(row);
              }}
            >
              <RiDeleteBinFill />
            </button>
          )}
        </div>
      ),
      allowOverflow: true,
      center: "true",
    },
  ]);
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    if (
      currentPage ||
      deleteDomainListData ||
      putDomainIdData ||
      postDomainData
    ) {
      let params = {};
      params.page = currentPage;
      params.page_size = perPage;
      dispatch(getDomainList(params));
    }
  }, [currentPage, deleteDomainListData, putDomainIdData, postDomainData]);
  useEffect(() => {
    if (domainListData) {
      setTableData(domainListData?.results);
      setTotalRows(domainListData?.totalRows);
    }
  }, [domainListData]);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    let params = {};
    params.page = page;
    params.page_size = newPerPage;
    dispatch(getDomainList(params));
    setPerPage(newPerPage);
  };

  const handleDomain = () => {
    if (
      addDomainName?.id &&
      addDomainName?.email_domain_mobile?.length > 0 &&
      addDomainName?.block_type?.length > 0
    ) {
      setAddDomainName({
        id: null,
        email_domain_mobile: "",
        block_type: "",
      });
      dispatch(putDomainId(addDomainName));
    }
    if (
      !addDomainName?.id &&
      addDomainName?.email_domain_mobile?.length > 0 &&
      addDomainName?.block_type?.length > 0
    ) {
      setAddDomainName({
        id: null,
        email_domain_mobile: "",
        block_type: "",
      });
      dispatch(
        postDomain({
          domain_list: addDomainName?.email_domain_mobile,
          block_type: addDomainName?.block_type,
        })
      );
    }
  };

  useEffect(() => {
    if (message) {
      setTimeout(() => {
        dispatch(cleardeleteDomainList());
      }, 5000);
    }
  }, [message]);

  return (
    <>
      {(deleteDomainListLoading ||
        postDomainDataLoading ||
        putDomainIdDataLoading) && <Loading />}
      <div className={"notification_popup"}>
        {message && (
          <Alert
            severity={
              deleteDomainListError ||
              postDomainDataError ||
              putDomainIdDataError
                ? `error`
                : `success`
            }
          >
            {message}
          </Alert>
        )}
      </div>
      <div className={"add_permission"}>
        <div className={"examfilter"}>
          <h4 className={"examfilter_heading"}>
            {addDomainName?.id ? "Edit" : "Add"} Domain
          </h4>
          <Form>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Domain Name</Form.Label>
                  <Form.Control
                    type="name"
                    placeholder="Enter domain and number in comma separated"
                    className={"input_pd"}
                    value={addDomainName?.email_domain_mobile}
                    onChange={(event) => {
                      setAddDomainName({
                        ...addDomainName,
                        email_domain_mobile: event.target.value,
                      });
                      setLengthError("");
                    }}
                  />
                  {lengthError && !addDomainName?.email_domain_mobile?.length > 0 && (
                    <div style={{ color: "red" }}>{lengthError}</div>
                  )}
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="status">
                  <Form.Label> Choices</Form.Label>
                  <Select
                    onChange={(obj) => {
                      setAddDomainName({
                        ...addDomainName,
                        block_type: obj?.label,
                      });
                      setLengthError("");
                    }}
                    name="Status"
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    options={domain_type}
                    value={domain_type?.find(
                      (item) => item?.label == addDomainName?.block_type
                    ) || ""}
                    isClearable={true}
                  />
                  {lengthError && !addDomainName?.block_type?.length > 0 && (
                    <div style={{ color: "red" }}>{lengthError}</div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={1}>
                <button
                  className={"btnInfo"}
                  onClick={(e) => {
                    e.preventDefault();
                    if (!addDomainName?.email_domain_mobile?.length > 0) {
                      setLengthError("Required *");
                    }
                    if (
                      addDomainName?.email_domain_mobile?.length > 0 &&
                      !addDomainName?.block_type?.length > 0
                    ) {
                      setLengthError("Required *");
                    }
                    handleDomain();
                  }}
                >
                  Submit
                </button>
              </Col>
              {addDomainName?.email_domain_mobile?.length > 0 && (
                <Col>
                  <button
                    className={"btnInfo"}
                    onClick={(e) => {
                      e.preventDefault();
                      setAddDomainName({
                        id: null,
                        email_domain_mobile: "",
                        block_type: "",
                      });
                    }}
                  >
                    Clear
                  </button>
                </Col>
              )}
            </Row>
          </Form>
        </div>
      </div>
      <div>
        <div className={"all_task"} style={{ marginTop: "40px" }}>
          <div className={"examfilter"}>
            <div className={"tablestrip"}>
              <div className={"tablestrip_left"}>
                <h4 className={"examfilter_heading"}>Manage Domain</h4>
              </div>
            </div>
            <div className={"exam_table_box"} style={{ marginTop: "20px" }}>
              {domainListLoading && <Loading />}
              {tableData && (
                <DataTable
                  columns={tableCustomData}
                  data={tableData}
                  customStyles={CUSTOM_STYLE_PERMISSION_DATA_TABLE}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <CommonModal
        isOpen={open}
        closeModal={() => {
          setOpen(false);
        }}
      >
        <div className="delete_confirmation">
          <div className="text_edit">
            Are you sure want to Delete this{" "}
            <span className="master_coaching_text_edit">
              {itemToDelete?.email_domain_mobile}
            </span>{" "}
            Domain ?
          </div>
          <div className="icon_buttons">
            <button
              className="icon_edits icon_yes_color"
              onClick={() => {
                setOpen(false);
                dispatch(deleteDomainList({ id: itemToDelete?.id }));
              }}
            >
              Yes
            </button>
            <button
              className="icon_edits icon_no_color"
              onClick={() => setOpen(false)}
            >
              No
            </button>
          </div>
        </div>
      </CommonModal>
    </>
  );
}

export default Domain;
